import { defineMessages } from 'react-intl';

export default defineMessages({
  checkOutBranchHeading: {
    id: 'frontbucket.repository.source.checkOutBranchHeading',
    description:
      'Heading describing options for checking out the branch of a repository',
    defaultMessage: 'Check out branch',
  },
  checkoutAction: {
    id: 'frontbucket.repository.source.checkOutAction',
    description:
      'Action to reveal options for checking out the source code of a repository',
    defaultMessage: 'Check out',
  },
  sourceTreeAction: {
    id: 'frontbucket.repository.source.sourceTreeCheckOutAction',
    description:
      'Action to check out the source code of a repository in SourceTree.',
    defaultMessage: 'Check out in SourceTree',
  },
  branchCharacterWarning: {
    id: 'frontbucket.repository.source.branchCharacterWarning',
    description: 'Warning if branch contains potentially dangerous characters',
    defaultMessage:
      'This branch name may have unintended effects in a Git command',
  },
});
